import { formatOptions } from 'components/formInputs/SelectField/utils';
import range from 'utils/range';

import { BloodPressureFormValues } from './types';

export const LABELS: Record<keyof BloodPressureFormValues, string> = {
  systolicPressure: 'What is your systolic pressure?',
  diastolicPressure: 'What is your diastolic pressure?',
  lastTreatedAt: 'When were you last treated for high blood pressure?',
  controlledWithMedication: 'Are you on any medication to control your blood pressure?',
  controlledWithMedicationSince:
    'When did you start taking medication to control your blood pressure?',
};
const SYSTOLIC_NUMBERS = formatOptions(range(120, 250));

export const SYSTOLIC_PRESSURE = [
  { label: "Don't know", value: 0 },
  { label: 'Less than 120', value: 119 },
  ...SYSTOLIC_NUMBERS,
];

const DIASTOLIC_NUMBERS = formatOptions(range(80, 180));

export const DIASTOLIC_PRESSURE = [
  { label: "Don't know", value: 0 },
  { label: 'Less than 80', value: 79 },
  ...DIASTOLIC_NUMBERS,
];
